/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {Typeahead} from 'react-bootstrap-typeahead'
import PropTypes from "prop-types";
import Block from "../../atoms/layout/Block";
import {withI18N} from "../../hoc/withI18N";

class _SearchTypeAhead extends React.Component {

    static propTypes = {
        placeholder: PropTypes.string,
        items: PropTypes.array.isRequired,
        maxItems: PropTypes.number,
        filterBy: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.string)]),
        onSelect: PropTypes.func.isRequired,
        disableFreeText: PropTypes.bool,
        renderMenu: PropTypes.func,
        emptyLabel: PropTypes.string,
        paginate: PropTypes.bool,
        size: PropTypes.string,
        searchIcon: PropTypes.node,
        paginationText: PropTypes.string,
        onPaginate: PropTypes.func,
        setRef: PropTypes.func
    };

    static defaultProps = {
        items: [],
        customMenu: false,
        paginate: false
    };

    state = {
        search: ''
    };

    typeahead = null;

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    handleChange = (item) => {
        if (item[0]) {
            this.props.onSelect(item[0]);
            if (this.typeahead) {
                this.typeahead.getInstance() && this.typeahead.getInstance().clear();
            }
        }
    };

    onInputChange = (event, isSubmit = false) => {
        if ((event.key && event.key.toLowerCase() === "enter" || isSubmit) && this.typeahead && this.typeahead.getInstance()) {
            this.props.onSelect(this.typeahead.getInstance().getInput().value);
            this.typeahead.getInstance().clear();
        }
    };

    render() {
        return <Block className="form-control-container">
            <Typeahead maxResults={this.props.maxItems}
                       paginate={this.props.paginate}
                       paginationText={this.props.translate("Show all results")}
                       onPaginate={this.props.onPaginate}
                       placeholder={this.props.placeholder}
                       minLength={2}
                       bsSize={this.props.size}
                       emptyLabel={this.props.emptyLabel}
                       labelKey="title"
                       filterBy={this.props.filterBy}
                       renderMenu={this.props.renderMenu}
                       maxHeight="auto"
                       ref={(typeahead) => {
                           this.typeahead = typeahead;
                           this.props.setRef && this.props.setRef(typeahead);
                       }}
                       onChange={this.handleChange}
                       onKeyDown={this.props.disableFreeText ? undefined : this.onInputChange}
                       options={this.props.items}
                       id="typeahead-input"/>
            {this.props.searchIcon ||
            <button onClick={(e) => this.onInputChange(e, true)} type="submit" className="p-filter-form__btn"><span
                className="svg-search-black-circle"/></button>}
        </Block>
    }

}

export const SearchTypeAhead = withI18N(_SearchTypeAhead);
